/**
 * @param key The key under which to store the value.
 * @param value The value to store; can be a string, object, or array.
 */
export const setSessionStorageItem = (key: string, value: unknown) => {
  const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
  sessionStorage.setItem(key, stringValue);
};

/**
 * @param key The key of the item to retrieve.
 * @returns The parsed value if it was stored as an object or array, otherwise the original string.
 */
export const getSessionStorageItem = (key: string) => {
  const item = sessionStorage.getItem(key);
  if (!item) return null;

  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
};
